// Pure helpers for the OAuth consent page (pages/OAuthConsent.jsx).
// Everything here reads the page's query string, which anyone can craft, so
// each helper mirrors a server-side rule rather than trusting the input.

// Mirrors isValidRedirectUri in api/utils/redirectUri.js: https, or http on
// loopback, no fragment. Anything else (javascript:, data:, …) returns null —
// the Deny button navigates to this URL, so a scheme that passes here runs on
// the portal origin.
export function parseSafeRedirectUri(uri) {
  let url;
  try {
    url = new URL(uri);
  } catch {
    return null;
  }
  if (url.hash) return null;
  if (url.protocol === 'https:') return url;
  if (url.protocol === 'http:' && (url.hostname === 'localhost' || url.hostname === '127.0.0.1')) {
    return url;
  }
  return null;
}

export const SCOPE_DESCRIPTIONS = {
  read: 'Read your schedules, bookings, and availability',
  write: 'Create and manage bookings, proposals, and event types',
  'availability:read:freebusy': 'See when you are free or busy',
  'availability:read:details': 'See details of your calendar events',
  'booking:propose': 'Propose meetings on your behalf',
};

// Mirrors parseScopes in api/v1/oauthServer.js: unknown scopes are dropped,
// and none left means read + write. The page shows what the server will
// record, never raw query-string text.
export function displayScopes(scopeParam) {
  const requested = String(scopeParam || '').split(' ').filter(Boolean);
  const known = requested.filter((scope) => Object.hasOwn(SCOPE_DESCRIPTIONS, scope));
  return known.length ? known : ['read', 'write'];
}
